// src/components/PaymentButtons.jsx
import React from "react";

export default function PaymentButtons({ total, onPay }) {
  return (
    <div className="payment-options">

      <h3>Select Payment Method</h3>

      {/* Stripe */}
      <button
        className="stripe-btn"
        onClick={() => onPay("Stripe")}
      >
        Pay with Credit/Debit (Stripe)
      </button>

      {/* PayPal */}
      <button
        className="paypal-btn"
        onClick={() => onPay("PayPal")}
      >
        Pay with PayPal
      </button>

      {/* Cash */}
      <button
        className="cash-btn"
        onClick={() => onPay("Cash")}
      >
        Pay with Cash on Pickup
      </button>
    </div>
  );
}
